import { useDispatch, useSelector } from "react-redux";
import Container from "../element/container";
import Col from "../element/col";
import Row from "../element/row";
import CommonCart from "../common/common.cart";
import CommonSummary from "../common/common.summary";
import { closeCartDropdown } from "../../redux/reducer/common.reducer";
import { useEffect } from "react";
import { getCartInfo } from "../../redux/reducer/cart.reducer";

export default function CartDropdown() {
  const dispatch = useDispatch();
  const { cartInfo, cartInfoLoading } = useSelector((state) => state.cart);

  return (
    (cartInfo?.items?.length > 0 || cartInfoLoading) && (
      <Container
        className="cart-dropdown"
        onClick={(e) => e.stopPropagation()}
        onMouseLeave={() => {
          dispatch(closeCartDropdown());
        }}
      >
        <Col className="pt-4 pb-4 px-4">
          <Row className="_row title">
            <h1 className="_label your-cart">Your Cart</h1>
            <p lassName="_label item-count">
              {!cartInfoLoading ? cartInfo?.total_item : ""} Item(s)
            </p>
          </Row>
          <Col className="_col cart-item-list">
            {cartInfoLoading
              ? Array.from({ length: 2 }, (_, cartLoadingIndex) => (
                  <CommonCart loading key={cartLoadingIndex} />
                ))
              : cartInfo?.items?.length > 0 &&
                cartInfo.items.map((cart, cartIndex) => (
                  <CommonCart data={cart} key={cartIndex} type="dropdown" />
                ))}
          </Col>
        </Col>
        <CommonSummary
          loading={cartInfoLoading}
          data={cartInfo}
          type="dropdown"
        />
      </Container>
    )
  );
}
